import { IUserProfile, IUserProfileInfo } from '../interfaces';
import { ICreateTicket } from '../interfaces/salesforce.interface';
import AxiosService from '../utils/axios-service';

export class SalesforceService extends AxiosService {
  private static instance: SalesforceService;

  constructor() {
    super('BFF_HELP_CENTER_URL');
  }

  static get getInstance(): SalesforceService {
    if (!SalesforceService.instance) {
      SalesforceService.instance = new SalesforceService();
    }
    return SalesforceService.instance;
  }

  public async createTicket(data: ICreateTicket): Promise<any> {
    try {
      const url: string = '/salesforce-ticket';
      const response = await this.axios.post(url, data);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async health(): Promise<any> {
    try {
      const url: string = '/health';
      const response = await this.axios.get(url);
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  public async userInfo(data: IUserProfileInfo): Promise<IUserProfile> {
    try {
      const url: string = '/user-profile';
      const response = (await this.axios.post(url, data)) as IUserProfile;
      return Promise.resolve(response);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  //   public async getUsers(email: string | null, token: string) {
  //     try {
  //       const headers: TServiceHeaders = { Authorization: `Bearer ${token}` };
  //       const url = `/user${email ? `/${email}` : ''}`;
  //       const processUser = (users: any) => {
  //         if (Array.isArray(users)) {
  //           return users.map((use) => new User(use));
  //         }
  //         return new User(users);
  //       };
  //       const users = await this.axios.get(url, { headers });
  //       return processUser(users);
  //     } catch (error) {
  //       return error;
  //     }
  //   }

  //   public async deleteUser(email: string, token: string) {
  //     try {
  //       const headers: TServiceHeaders = { Authorization: `Bearer ${token}` };
  //       const url = `/user/${email}`;
  //       const response = await this.axios.delete(url, { headers });
  //       return response;
  //     } catch (error) {
  //       return error;
  //     }
  //   }

  //   public async updateUser(email: any, specs: any, token: string) {
  //     try {
  //       const headers: TServiceHeaders = { Authorization: `Bearer ${token}` };
  //       const url = `/user/${email}`;
  //       const response = await this.axios.patch(url, specs, { headers });
  //       return response;
  //     } catch (error) {
  //       return error;
  //     }
  //   }
}

export default SalesforceService.getInstance;
